export default __webpack_public_path__ + "static/media/ServeX.4b0c01e0.svg";